import React from "react";
export default function About() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <h1 className="font-heading text-4xl sm:text-5xl font-bold text-gray-900">About Access Local</h1>
      <div className="mt-6 space-y-5 text-lg text-gray-700 leading-relaxed">
        <p>Access Local is a community-first platform that ranks and showcases the most accessible places in Swindon and Wiltshire — with a mission to expand across the UK.</p>
        <p>Too often, accessibility information is buried, out of date, or missing entirely. We bring it to the surface: real ratings, clear features, and the details you need before you visit.</p>
        <p>We are built on three pillars: <strong>trust</strong> (independent inspectors grade every venue), <strong>community</strong> (members nominate the places that matter), and <strong>transparency</strong> (a consistent framework you can review).</p>
      </div>
    </div>
  );
}
